import Vue from 'vue';

export default Vue.extend({
  methods: {
    changeLoadingMessage(ref, messageVariable, newValue): void {
      ref.classList.add('switching-message');
      ref.addEventListener('transitionend', () => {
        this[messageVariable] = newValue;
        ref.classList.remove('switching-message');
      }, false);
    },
  },
});
